import { useCallback, useEffect, useState } from 'react'
import { aiToolsAvailable, listConsumers } from './ai-tools-api'

// The consumers that have marked anything (GET /admin/consumers), for the
// lists' Consumer filter and the mark dialog: [consumers, reload]. [] until
// read; a failed read keeps what was there (the filter then offers "Any
// consumer" alone, and the dialog takes a typed name). A build that doesn't
// know the ai service (aiToolsAvailable) asks nothing. A state value and a
// stable function, never a fresh object (api-new's hooks are, and loop in
// an effect that calls them), so either is safe in an effect's deps.
export const useConsumers = () => {
  const [consumers, setConsumers] = useState([])
  const reload = useCallback(() => {
    if (!aiToolsAvailable()) return Promise.resolve()
    return listConsumers().then(
      body => setConsumers(body && Array.isArray(body.consumers) ? body.consumers : []),
      () => {}
    )
  }, [])
  useEffect(() => { reload() }, [reload])
  return [consumers, reload]
}
